var actions, types;

types = {
  INVALIDATE_USER: 'invalidate-user',
  LOGIN_USER: 'request-user',
  RECEIVE_USER: 'receive-user',
  JOINED_GAME: 'joined-game',
  SESSION_LOGIN: 'session-login',
  LOGOUT: 'logout',
  LOGGED_OUT: 'logged-out',
  FAILED_LOGIN: 'failed_login',
  DISMISS_ERROR: 'dismiss_error'
};

actions = {
  invalidateUser: function() {
    return {
      type: types.INVALIDATE_USER
    };
  },
  loginUser: function(nickname) {
    app.socket.emit('data', {
      endpoint: '/user/login',
      value: nickname
    });
    return {
      type: types.LOGIN_USER
    };
  },
  sessionLogin: function(session) {
    app.socket.emit('data', {
      endpoint: '/user/sessionLogin',
      value: session
    });
    return {
      type: types.SESSION_LOGIN
    };
  },
  joinedGame: function(gameId) {
    return {
      type: types.JOINED_GAME,
      gameId: gameId
    };
  },
  logout: function() {
    app.socket.emit('data', {
      endpoint: '/user/logout'
    });
    return {
      type: types.LOGOUT
    };
  },
  loggedOut: function() {
    return {
      type: types.LOGGED_OUT
    };
  },
  failedLogin: function(errorMessage) {
    if (errorMessage == null) {
      errorMessage = '';
    }
    return {
      type: types.FAILED_LOGIN,
      errorMessage: errorMessage
    };
  },
  dismissError: function() {
    return {
      type: types.DISMISS_ERROR
    };
  },
  receiveUser: function(user) {
    return {
      type: types.RECEIVE_USER,
      data: user,
      receivedAt: Date.now()
    };
  }
};

Object.assign(actions, types);

module.exports = actions;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/actions/user.coffee
 ** module id = 244
 ** module chunks = 0
 **/